import React, { useMemo, useState } from 'react';
import { Segment, TabPanel, Tabs } from 'tea-component';
import DateSelect from '@op/components/FilterCommon/widgets/DateSelect';
import { getLocale } from 'umi';
import moment from 'moment';
import CommonChart from './CommonChart';
import { ClassSpecial } from '@op/constants/common';
import { MetricItemType } from '../LeftMetrics';
import './index.scss';
import _ from 'lodash-es';
import useLanguage from '@op/hooks/useLanguage';

export default function RightChart({
  metricItem,
  gameInfo,
  filter: oriFilter,
}: {
  metricItem: MetricItemType;
  gameInfo: any;
  filter: any;
}) {
  const { formatMessage } = useLanguage();
  const [groupFields, setGroupFields] = useState('all');
  const [effectiveTime, setEffectiveTime] = useState({
    start_time: moment(oriFilter?.start_time).format('YYYY-MM-DD HH:mm:ss'),
    end_time: moment(oriFilter?.end_time).format('YYYY-MM-DD HH:mm:ss'),
    date_type: 'weekly',
  });

  const options = useMemo(() => {
    const { name, hasLanguage = true } = metricItem || {};
    const list = [
      {
        text: formatMessage(name),
        value: 'all',
      },
      {
        text: formatMessage('By Language'),
        value: 'language',
      },
      {
        text: formatMessage('By Channel'),
        value: 'channel',
      },
    ];

    if (!hasLanguage) {
      return list.filter((item) => item.value !== 'language');
    }

    return list;
  }, [formatMessage]);

  const filter = useMemo(() => {
    if (!oriFilter) return null;
    return { ...oriFilter, ...effectiveTime };
  }, [effectiveTime]);

  return (
    <div className="dbo-right-charts">
      <div className="dbo-right-charts-filter">
        <Segment
          value={groupFields}
          onChange={(value: any) => {
            setGroupFields(value);
          }}
          options={options}
        />
        <div className="dbo-right-charts-filter-time">
          <DateSelect
            dateTypeList={['week']}
            showTimeTips={false}
            hasDiffClassName={false}
            lang={getLocale()}
            defaultOptionsMap={{
              week: { value: 'week', text: 'Week', text_cn: '周' },
            }}
            gameInfo={gameInfo}
            filterOptions={{ time: moment().format('YYYY-MM-DD') }}
            defaultValue={effectiveTime}
            onChange={(timeKey: any, result: any) => {
              const value = result?.value;
              if (
                value.start_time &&
                value.end_time &&
                !_.isEqual(value, effectiveTime)
              ) {
                setEffectiveTime({ ...result?.value });
              }
            }}
          />
        </div>
      </div>

      <div>
        <Tabs
          activeId={groupFields}
          className={ClassSpecial.TAB_NONE}
          tabs={options.map((item) => ({ id: item.value, label: item.text }))}
        >
          {options.map((item) => {
            return (
              <TabPanel key={item.value} id={item.value}>
                <CommonChart
                  metricItem={metricItem}
                  filter={filter}
                  type={item.value as 'all'}
                ></CommonChart>
              </TabPanel>
            );
          })}
        </Tabs>
      </div>
    </div>
  );
}
